/**
 * Build GET /dashboard query params from date-range pickers.
 * Task and bug ranges are independent (backend filters each block separately).
 *
 * @param {{ startDate?: string, endDate?: string } | null} taskRange
 * @param {{ startDate?: string, endDate?: string } | null} bugRange
 */
export function buildDashboardQueryParams(taskRange, bugRange) {
  const q = {};
  if (taskRange?.startDate && taskRange?.endDate) {
    q.taskDateFrom = String(taskRange.startDate).trim();
    q.taskDateTo = String(taskRange.endDate).trim();
  }
  if (bugRange?.startDate && bugRange?.endDate) {
    q.bugDateFrom = String(bugRange.startDate).trim();
    q.bugDateTo = String(bugRange.endDate).trim();
  }
  return q;
}
